// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3FiZ8","modalForm":"UpgradeEpcsModal_modalForm__2gtKH","modalFooter":"UpgradeEpcsModal_modalFooter__3e1c7"};